import { useState } from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/icons";
import { McInput } from "@maersk-global/mds-react-wrapper/components-core/mc-input";
import { useStore } from "../../../../store/store.context";
import { formattedTime } from "../../../../utils/helper";

import "./message-item.scss";

const MessageItem = ({ message }) => {
  const [inputValue, setInputValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const { updateStore } = useStore();

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setInputValue(e.target.value)
      updateStore({ remarksReason: e.target.value });
      setIsDisabled(true);
    }
  };
  return (
    <div
      className={`message-item ${
        message.isUser ? "message-user" : "message-assistant"
      }`}
    >
      <div className="message-header">
        {!message.isUser && <McIcon color="#2596be" icon="chatbot" size="24" />}

        <div className="message-info">
          <div className="message-author">
            {message.isUser ? "You" : "Digital Assistant"}
          </div>
          <div className="message-timestamp">
            {message.timestamp ? formattedTime(message.timestamp) : ""}
          </div>
        </div>
      </div>
      {/* Message Text */}
      <div
        className={`message-text ${
          message.isUser ? "user-text" : "assistant-text"
        }`}
      >
        {message.text}

        {/* Render Input field if inputs exist */}
        
        
        {message.inputs && (
          <McInput
            label=""
            placeholder="Type Remark reason.."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            disabled={isDisabled}
            onKeyDown={(e)=>handleKeyDown(e)}
          />
        )}
      </div>

    </div>
  );
};

export default MessageItem;
